<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            {{ document?._template?.name }}
        </div>

        <button type="button" (click)="closeDialog()" [attr.data-testid]="'upload-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="hypo-dialog-content" [attr.data-testid]="'upload-dialog'">
        <div class="dialog-inner flex flex-col gap-5 box-border w-full items-center place-content-center">
            @if (document.status === 'waiting' && document?._template?.description) {
                <app-info-panel type="warning" class="flex flex-row w-full gap-2">
                    {{ document?._template?.description }}
                </app-info-panel>
            }

            @if (showInfoBox) {
                <app-info-panel type="info" class="flex flex-row w-full gap-2">
                    @if (document.status === 'checking') {
                        <div>Dokumenty byly úspěšně odeslány vašemu specialistovi a právě se kontrolují.</div>
                    }
                    @if (['checked', 'done'].includes(document.status)) {
                        <div>
                            <strong>Zde máte hotovo.&nbsp;</strong>
                            <span>Nahraný dokument jsme zkontrolovali a je v pořádku.</span>
                        </div>
                    }
                </app-info-panel>
            }

            <div class="flex flex-col w-full">
                <div class="mb-4">
                    <h2 class="contact-name text-xl font-semibold pb-0.5">
                        {{ document.contactId | applicantName: mortgage._contacts }}
                    </h2>
                    @if (document.providerId) {
                        <div class="provider-info text-sm">
                            {{ document?.providerId | providerNameById | async }}
                        </div>
                    }
                </div>

                @if (documentTypes?.length) {
                    <div
                        appHasError="appHasError"
                        #documentTypeHasError="appHasError"
                        class="document-type-container flex flex-col mb-4">
                        <div class="documents-dialog-table-header mb-2"><p>O jaký typ dokumentu se jedná?</p></div>
                        <div class="flex flex-row flex-wrap">
                            <mat-radio-group [formControl]="documentTypeControl" class="flex flex-row flex-wrap gap-2">
                                @for (documentType of documentTypes; track documentType) {
                                    <mat-radio-button
                                        [value]="documentType"
                                        matRipple
                                        matRippleColor="#02c57d18"
                                        [disableRipple]="true">
                                        {{ documentType }}
                                    </mat-radio-button>
                                }
                            </mat-radio-group>
                        </div>
                        @if (documentTypeHasError.invalid) {
                            <app-info-panel type="error"> Vyberte prosím typ dokumentu. </app-info-panel>
                        }
                    </div>
                }

                @if (waitingForSignature) {
                    <h2>1. Stáhnout a podepsat dokumenty</h2>
                    <div class="files-to-download flex flex-row items-center box-border place-content-center mb-4">
                        @for (file of filesToDownloadForSignature; track file) {
                            <app-file-item [file]="file" (click)="showPreview(file.documentFile)"> </app-file-item>
                        }
                    </div>
                }

                @if (waitingForSignature) {
                    <h2 class="mb-4">2. Nahrát podepsaný dokument zpět</h2>
                }

                @if (isUploadable && isDesktop) {
                    <mat-expansion-panel
                        (afterExpand)="qrCodePanelExpanded()"
                        [expanded]="uploadByMobileExpanded"
                        #expansionPanel="matExpansionPanel"
                        class="mb-4">
                        <mat-expansion-panel-header>
                            <h2>Focení nebo nahrávání vyfocených stránek z mobilu</h2>
                        </mat-expansion-panel-header>
                        <div class="flex flex-row items-stretch justify-between">
                            <ol class="flex flex-col grow justify-evenly items-start">
                                <li>Otevřete na svém mobilním zařízení fotoaparát.</li>
                                <li>Nasměrujte fotoaparát na QR kód a potvrďte výběr.</li>
                                <li>Pokračujte v nahrávání na mobilním zařízení</li>
                            </ol>
                            <div class="canvas-wrapper" [class.loaded]="magicLinkUrlLoaded">
                                <canvas class="qr-code" #canvas></canvas>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }

                @if (!waitingForSignature && filesToDownloadForSignature.length > 0) {
                    <h2 class="mt-4">Dokumenty k podpisu</h2>
                    <div class="files-to-download fx-r fx-pc-c-c">
                        @for (file of filesToDownloadForSignature; track file) {
                            <app-file-item [file]="file" (click)="showPreview(file.documentFile)"> </app-file-item>
                        }
                    </div>
                    <h2>Vámi nahrané dokumenty</h2>
                }

                <input
                    #uploaderInput
                    id="uploaderInput"
                    [uploader]="uploader"
                    hidden="hidden"
                    multiple="multiple"
                    name="uploaderInput"
                    ng2FileSelect="ng2FileSelect"
                    [attr.data-testid]="'upload-dialog-uploader-input'"
                    type="file" />

                <input
                    #cameraUploaderInput
                    id="cameraUploaderInput"
                    [uploader]="uploader"
                    hidden="hidden"
                    multiple="multiple"
                    name="cameraUploaderInput"
                    ng2FileSelect="ng2FileSelect"
                    type="file"
                    [attr.data-testid]="'upload-dialog-camera-uploader-input'"
                    capture="environment" />

                <div
                    class="uploader flex flex-col mt-4"
                    ng2FileDrop="ng2FileDrop"
                    [class.rejected]="hasSomeRejectedFiles"
                    [class.uploadable]="isUploadable"
                    [uploader]="uploader"
                    (fileOver)="hasFileOver = !!$event"
                    [ngClass]="{
                        'file-over': hasFileOver,
                        'has-error': fileDropError,
                        'camera-preview': showCameraPreview,
                    }">
                    @if (showCameraPreview) {
                        <button
                            class="close-camera-upload"
                            @zoomInOnEnter
                            mat-mini-fab="mat-mini-fab"
                            color="warn"
                            (click)="showCameraPreview = false">
                            <mat-icon>close</mat-icon>
                        </button>
                        <app-camera-snapshot (snapshot)="saveSnapshotFromWebcam($event)"></app-camera-snapshot>
                    } @else {
                        <div class="queue flex flex-row fx-pc-fs-c" #filesQueue>
                            @for (sample of document.samples || []; track sample) {
                                <a
                                    target="_blank"
                                    download="download"
                                    [href]="
                                        'https://www.hyponamiru.cz/wp-content/uploads/document-samples/' +
                                        sample.sampleDocument
                                    ">
                                    <app-file-item
                                        @bounceInOnEnter
                                        [file]="createSampleFilePlaceholder(sample.sampleDocument)">
                                    </app-file-item>
                                </a>
                            }
                            @if (queue.length === 0 && document.samples?.length === 0 && !animationInProgress) {
                                <app-file-item @bounceInOnEnter file="empty" (click)="uploaderInput.click()">
                                </app-file-item>
                            }
                            @for (item of queue; track item; let index = $index) {
                                <app-file-item
                                    [file]="item"
                                    (performAction)="fileIconActionClick($event, index)"
                                    (click)="showPreview(item.documentFile)"
                                    [@.disabled]="!isUploadable"
                                    [@bounceInOnEnter]
                                    @zoomOutOnLeave
                                    (@zoomOutOnLeave.done)="animationInProgress = false"
                                    (@zoomOutOnLeave.start)="animationInProgress = true">
                                </app-file-item>
                            }
                        </div>
                        @if (isUploadable) {
                            <div class="flex flex-col gap-5 w-full">
                                <div class="flex flex-col w-full gap-2 items-center justify-around md:flex-row">
                                    <button
                                        class="btn btn-lg primary-transparent max-md:w-11/12"
                                        [attr.data-testid]="'upload-dialog-button-choose-file'"
                                        mat-button="mat-button"
                                        type="button"
                                        (click)="uploaderInput.click()">
                                        <div class="flex flex-row gap-2 items-center justify-center">
                                            <mat-icon>attach_file</mat-icon>
                                            <span>Vybrat soubor</span>
                                        </div>
                                    </button>
                                    @if (!isDesktop) {
                                        <button
                                            class="btn btn-lg primary-transparent max-md:w-11/12"
                                            mat-button="mat-button"
                                            type="button"
                                            [attr.data-testid]="'upload-dialog-button-camera1'"
                                            (click)="cameraUploaderInput.click()">
                                            <div class="flex flex-row gap-2 items-center justify-center">
                                                <mat-icon>photo_camera</mat-icon>
                                                <span>Vyfotit</span>
                                            </div>
                                        </button>
                                    }
                                    @if (cameraSupported && isDesktop) {
                                        <button
                                            class="btn btn-lg primary-transparent max-md:w-11/12"
                                            mat-button="mat-button"
                                            type="button"
                                            [attr.data-testid]="'upload-dialog-button-camera2'"
                                            (click)="cameraMode()">
                                            <div class="flex flex-row gap-2 items-center justify-center">
                                                <mat-icon>photo_camera</mat-icon>
                                                <span>Vyfotit kamerou</span>
                                            </div>
                                        </button>
                                    }
                                </div>
                                <div class="drag-title" [hidden]="isDesktop"></div>
                                <div class="drag-title" [hidden]="!isDesktop">Nebo sem přetáhněte soubory</div>
                            </div>
                        }
                        @if (document.status === 'checking' && !isUploadable) {
                            <div class="checking-info flex flex-col items-center justify-center" @zoomInOnEnter>
                                <strong>Soubory v tuto chvíli kontrolujeme a není možné je měnit.&nbsp;</strong>
                                <span>Chcete-li provést změnu, kontaktujte svého hypotečního specialistu, prosím.</span>
                            </div>
                        }
                    }
                </div>

                @if (hasSomeRejectedFiles) {
                    <div class="rejection-reasons fx-c fx-pc-c-c">
                        <div class="flex flex-row">
                            <strong>Některé soubory byly zamítnuty.&nbsp;</strong>
                            <span>Prosím, nahrajte je znovu.</span>
                        </div>
                        @for (rejectionReason of rejectionReasons; track rejectionReason) {
                            <div class="flex flex-col">
                                <div>
                                    <strong>Důvod zamítnutí:&nbsp;</strong>
                                    <span>{{ rejectionReason }}.</span>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>

    @if (isUploadable && !showCameraPreview) {
        <div class="hypo-dialog-footer bg-white-force">
            <button
                (click)="uploadFiles()"
                [attr.data-testid]="'upload-dialog-button-upload'"
                [disabled]="(uploader.isUploading || uploader.queue.length === 0) && !filesChanged"
                mat-button="mat-button"
                type="button"
                class="btn btn-lg orange w-11/12 md:w-2/5">
                @if (!mainService.showLoader) {
                    Odeslat specialistovi
                }
                @if (mainService.showLoader) {
                    <mat-spinner diameter="24"></mat-spinner>
                }
            </button>
        </div>
    }
</mat-dialog-content>

<app-file-preview [files]="filesToPreview" [index]="filePreviewIndex" [(display)]="previewIsVisible">
</app-file-preview>

<app-pdf-viewer [(visible)]="pdfVisible" [fileUrl]="pdfFileUrl" [filename]="pdfFilename"> </app-pdf-viewer>
